import { useEffect, useState } from "react";

/** The current time, re-read every `everyMs`: a render clock for a countdown on screen.
 *  It only re-renders and never fetches, so it is not the status polling doctrine 1.2
 *  bans; the timer's end is data the page already holds. */
export function useNow(everyMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), everyMs);
    return () => window.clearInterval(id);
  }, [everyMs]);
  return now;
}
